// extracted by mini-css-extract-plugin
export default {"searchbar":"searchbar_searchbar__7HwnL","input":"searchbar_input__+v5cS","submit-btn":"searchbar_submit-btn__AhkCu"};